import SafeImage from '@/components/SafeImage';

const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Movie%20poster%20style%20image%20of%20a%20mysterious%20ancient%20Chinese%20palace%20at%20night%20with%20lanterns%20and%20fog%2C%20dramatic%20cinematic%20lighting%2C%20warm%20amber%20and%20deep%20blue%20contrast%2C%20historical%20drama%20aesthetic%2C%20no%20text%20or%20logos%2C%20vertical%20orientation&width=600&height=800&seq=card-movie-01&orientation=portrait',
    title: '长安秘闻录',
    tag: '古装悬疑',
    rating: '8.7',
    desc: '大唐年间一桩离奇命案，揭开深宫秘密。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20with%20neon%20lights%20and%20flying%20vehicles%20at%20dusk%2C%20cyberpunk%20aesthetic%2C%20dramatic%20perspective%2C%20warm%20neon%20orange%20and%20teal%20accents%2C%20cinematic%20composition%2C%20no%20text%2C%20movie%20poster%20style&width=600&height=800&seq=card-movie-02&orientation=portrait',
    title: '星际迷途',
    tag: '科幻冒险',
    rating: '8.4',
    desc: '人类最后的星际远航，探索未知宇宙。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Two%20young%20lovers%20silhouette%20against%20a%20warm%20sunset%20sky%20in%20a%20field%20of%20wildflowers%2C%20romantic%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20dreamy%20bokeh%20effect%2C%20tender%20moment%2C%20cinematic%20widescreen%20composition%2C%20no%20text&width=600&height=800&seq=card-movie-03&orientation=portrait',
    title: '盛夏光年',
    tag: '青春爱情',
    rating: '8.1',
    desc: '那个夏天，所有的故事都与你有关。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20alley%20in%20rainy%20city%20with%20a%20detective%20silhouette%20under%20streetlamp%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20film%20noir%20cinematography%2C%20moody%20blue%20and%20amber%20tones%2C%20suspenseful%20composition%2C%20no%20text&width=600&height=800&seq=card-movie-04&orientation=portrait',
    title: '暗夜追踪',
    tag: '犯罪悬疑',
    rating: '8.9',
    desc: '一宗连环案件背后的惊人真相。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20fantasy%20world%20with%20floating%20islands%20and%20magical%20creatures%2C%20vibrant%20warm%20colors%2C%20dreamy%20atmosphere%2C%20Studio%20Ghibli%20inspired%20aesthetic%2C%20soft%20painterly%20style%2C%20no%20text%2C%20vertical%20composition&width=600&height=800&seq=card-movie-05&orientation=portrait',
    title: '云端幻想曲',
    tag: '动画奇幻',
    rating: '9.0',
    desc: '在云之彼端，开启一场奇幻冒险。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Intense%20courtroom%20scene%20with%20dramatic%20lighting%20and%20tension%2C%20lawyers%20arguing%2C%20wooden%20panels%2C%20warm%20side%20lighting%20through%20tall%20windows%2C%20legal%20drama%20aesthetic%2C%20cinematic%20composition%2C%20no%20text%2C%20premium%20film%20look&width=600&height=800&seq=card-movie-06&orientation=portrait',
    title: '正义之名',
    tag: '律政剧情',
    rating: '8.3',
    desc: '当正义与利益交锋，谁才是真正的赢家。',
  },
];

export default function CardsSection() {
  const handleCardClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          热门影视
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          精选高分好片，每一部都值得你花时间
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card, idx) => (
            <a
              key={idx}
              href="#hero"
              onClick={handleCardClick}
              className="group block bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-50"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <SafeImage
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2.5 right-2.5">
                  <span className="px-2 py-1 rounded-lg bg-background-50/90 text-accent-600 text-xs font-bold whitespace-nowrap">
                    {card.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 md:p-4">
                  <span className="text-[10px] md:text-xs text-primary-300 font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-1">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}